import type { GeneratedColumn } from "building-types/columns/columnGeneratedTypes";
import type { ColumnHandle, DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { ExteriorMaterial } from "building-types/materials/exteriorMaterialTypes";
import uid from "common/utils/uid";
import { buildingEntityBaseNew } from "doc/utils/buildingEntityTools";
import type { Extrusion } from "geom/brep";
import type { PolyLine2 } from "geom/polyLine2Types";

export function generatedColumnNew(
  levelId: string,
  roomId: string,
  edgeId: string,
  planProfiles: PolyLine2[],
  extrusions: Extrusion[],
  paletteId: ExteriorMaterial,
  handle: ColumnHandle,
  pickHandle: DocEntityHandle,
  isolatedAssemblyId: string | undefined,
): GeneratedColumn {
  return {
    ...buildingEntityBaseNew("COLUMN", uid()),
    levelId,
    roomId,
    edgeId,
    planProfiles,
    extrusions,
    isolatedAssemblyId: isolatedAssemblyId !== undefined ? isolatedAssemblyId : "",
    handle,
    paletteId,
    pickHandle,
  };
}
